import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=8579ce9c&scoped=true"
import script from "./Recovery.vue?vue&type=script&lang=ts"
export * from "./Recovery.vue?vue&type=script&lang=ts"
import style0 from "./Recovery.vue?vue&type=style&index=0&id=8579ce9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8579ce9c",
  null
  
)

export default component.exports